import {useEffect, useRef, useState} from 'react';
import styles from './discountInfo.module.scss';
import { ReactComponent as ArrowSVG } from 'assets/icon-arrow-right.svg';
import discountInfo from "assets/discountInfo.jpg"; 
import {getCouponDetail} from "../../api/query";
import {useAuth} from "../../context/Auth";
import {useLocation, useParams} from 'react-router-dom';
import Dialog from 'components/Dialog';
import { useGlobalError } from 'context/Error/GlobalErrorContext';


const CouponDetail = () => {
  const [doubleCheckVisible, setDoubleCheckVisible] = useState<boolean>(false);
  const { accessToken } = useAuth();
  const { pathname } = useLocation();
  const { couponId } = useParams();
  const [coupon,setCoupon] = useState<any>(undefined);
  const [codeCopy,setCopy] = useState(false);
  const promotionCode = useRef<string>('');
  const promotionUrl = useRef<string>('');
  const [expiredButton,setExpiredButton] = useState(false);
  const { showError } = useGlobalError()

  const now = new Date();

  useEffect(()=>{
    if(pathname){
      fetchCoupom();
    }
    // eslint-disable-next-line
  },[pathname]);
  
  const fetchCoupom = async() =>  {
    try{
      const { data } = await getCouponDetail(accessToken! , Number(couponId!));
      if(!data){
        return 'coupon not found';
      }else{
        // getCouponDetail 回的是「這位會員已領的券清單」,不是單一張券。
        // 原本寫成 data.data.data 又多剝一層,拿到 undefined,一讀 expired_at 就整頁白屏
        // (同仁回報「所有優惠券都是」)。這裡改成從清單挑出網址上的那張。
        const list: any[] = Array.isArray(data.data)
          ? data.data
          : Array.isArray((data.data as any)?.data)
            ? (data.data as any).data
            : [];
        const couponData = list.find((c) => String(c?.id) === String(couponId)) ?? list[0];

        if (couponData) {
          setCoupon(couponData);
          promotionCode.current = couponData.promotion_code ?? '';
          promotionUrl.current = couponData.promotion_url ?? '';

          // 沒有到期日就不當作過期(後端可能回空字串)
          const expiredDate = couponData.expired_at ? new Date(couponData.expired_at) : null;
          setExpiredButton(
            expiredDate !== null &&
              !Number.isNaN(expiredDate.getTime()) &&
              expiredDate.getTime() < now.getTime()
          );
        } else {
          setCoupon(undefined);
        }
      }
    }catch(e: any){
      console.log(e);
      showError(e, 'error')
    }
  }
  
  const onCopy = () => {
    if (!navigator.clipboard) {
      return; // Clipboard API not available
    }
    
    if(promotionCode.current){
      navigator.clipboard
        .writeText(promotionCode.current)
        .then(() => {
          setCopy(true);
        })
        .catch((err) => {
          console.log('Something went wrong', err);
        });  
      }
  };

  const showDoubleCheckConfirm = () => {
    setDoubleCheckVisible(true);
  }

  const onCancel= () => {
    setDoubleCheckVisible(false);
  };

  const onCancelButtonClick = () => {
    setDoubleCheckVisible(false);
  };

  const onDoubleCheckConfirm = () => {
    if (coupon?.promotion_url) {
      if (coupon?.promotion_url.includes('http')) {
        window.open(coupon?.promotion_url); 
      }
    }
    setDoubleCheckVisible(false);
  };
  
  return (
    <>
      <div className={styles.discountInfo}>
        <div className={styles.imgWrap}>
          <div className={styles.imgInner}>
            <img src={discountInfo} alt="couponImage" className={styles.img} />
          </div>
        </div>
        <div className={styles.redeemCode}>
          <div className={styles.code}>
            { !expiredButton ?
              (
                <>
                  <h3>{ coupon?.promotion_code ? coupon?.promotion_code : '點擊下方按鈕，前往兌換' }</h3>
                  <span>
                    {coupon?.promotion_code?(codeCopy?'已成功複製代碼，點擊下方按鈕，前往兌換':'複製代碼，點擊下方按鈕，前往兌換'):''}
                  </span>
                </>
              )
              :
              (
                <h3>兌換券已超過兌換期限</h3>
              )
            }
              {/* <span>{codeCopy?'已成功複製代碼，點擊下方按鈕，前往兌換':'複製代碼，點擊下方按鈕，前往兌換'}</span> */}
          </div>
          {
            (coupon?.promotion_code && !expiredButton) && (
              <div className={styles.copyBtn}>
                <button onClick={onCopy}>
                  {/* {typeRef.current === 'online' ? '複製代碼' : '確認兌換'} */}
                  複製代碼
                </button>
              </div>
            )
          }
        </div>
        <div className={styles.extra}>
          <div className={styles.dates}>
          兌換期限：{coupon?.start_at && coupon?.start_at.slice(0,10)} ~ {coupon?.expired_at && coupon?.expired_at.slice(0,10)}
          </div>
          <div className={styles.description}>
            {coupon?.title}
            <br/><br/>
            {coupon?.description}<br/>
          </div>
          {
            (!expiredButton && coupon?.promotion_url) && (
              <button className={styles.btn} onClick={
                showDoubleCheckConfirm 
              } disabled={expiredButton}>
                <span>前往兌換</span>
                <ArrowSVG />
              </button>
            )
          }
        </div>
      </div>
      <Dialog
        visible={doubleCheckVisible}
        message={
          <div className={styles.message}>
            <h2>即將前往外部網站？</h2>
          </div>
        }
        onCancel={onCancel}
        onConfirm={onDoubleCheckConfirm}
        onCancelButtonClick={onCancelButtonClick}
        cancelable
        cancelText="取消"
        okText="確認"
      />
    </>
  );
};

export default CouponDetail;
